/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Password_MinInputs */

const es_co2_signup_error_password_min = /** @type {(inputs: Signup_Error_Password_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mínimo 6 caracteres`)
};

/**

* @param {Signup_Error_Password_MinInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_password_min = /** @type {((inputs?: Signup_Error_Password_MinInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Password_MinInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_password_min(inputs)
});